import { Paginated } from "src/@types/paginated";
import { Tags } from "../enum/tags";
import { apiSlice } from "./http";
import {
  IAccountingAccount,
  IAccountingAccountActive,
  IAccountingAccountCreate,
  IAccountingAccountParams,
  IAccountingAccountUpdate,
} from "src/@types/account-accouting";

export const accountAccoutingInformations = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createAccountingAccount: builder.mutation<string, IAccountingAccountCreate>(
      {
        query: (accountingAccount: IAccountingAccountCreate) => ({
          url: "/justification-account",
          method: "POST",
          body: accountingAccount,
        }),
        invalidatesTags: [
          Tags.ACCOUNTING_ACCOUNT,
          Tags.ACCOUNTING_ACCOUNT_ACTIVE,
        ],
      }
    ),
    updateAccountingAccount: builder.mutation<string, IAccountingAccountUpdate>(
      {
        query: (accountingAccount: IAccountingAccountUpdate) => ({
          url: `/justification-account/${accountingAccount.id}`,
          method: "PUT",
          body: accountingAccount,
        }),
        invalidatesTags: [
          Tags.ACCOUNTING_ACCOUNT,
          Tags.ACCOUNTING_ACCOUNT_ACTIVE,
          Tags.JUSTIFICATION,
        ],
      }
    ),
    getAccountingAccounts: builder.query<
      Paginated<IAccountingAccount>,
      IAccountingAccountParams
    >({
      query: ({ search, meta, orderBy }) => {
        const params = new URLSearchParams({
          search,
          orderBy,
          page: meta.page.toString(),
          perPage: "15",
        });

        return {
          url: `/justification-account?${params.toString()}`,
          method: "GET",
        };
      },

      providesTags: [Tags.ACCOUNTING_ACCOUNT],
    }),
    getAccountingAccountsActive: builder.query<
      IAccountingAccountActive[],
      void
    >({
      query: () => {
        return {
          url: `/justification-account/active`,
          method: "GET",
        };
      },

      providesTags: [Tags.ACCOUNTING_ACCOUNT, Tags.ACCOUNTING_ACCOUNT_ACTIVE],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetAccountingAccountsQuery,
  useCreateAccountingAccountMutation,
  useUpdateAccountingAccountMutation,
  useGetAccountingAccountsActiveQuery,
} = accountAccoutingInformations;

export const {
  endpoints: {
    getAccountingAccounts: { select: selectGetStores },
    createAccountingAccount: { select: selectCreateStore },
    updateAccountingAccount: { select: selectUpdateStore },
    getAccountingAccountsActive: { select: selectGetStoresActive },
  },
} = accountAccoutingInformations;
